import AppHeader from "../../layout/AppHeader";
import User from '../../xpost/views/register/user/User.vue';
import UserAdd from '../../xpost/views/register/user/UserAdd.vue';

const UserRoutes = [
    {
        path: "/cadastro/usuario",
        name: "user",
        components: {
            header: AppHeader,
            default: User
        }
    },
    {
        path: "/cadastro/usuario/adicionar",
        name: "user.add",
        components: {
            header: AppHeader,
            default: UserAdd
        }
    },
    {
        path: '/cadastro/usuario/adicionar/:id',
        name: 'user.edit',
        components: {
            header: AppHeader,
            default: UserAdd
        }
    }
]

export default UserRoutes;